var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.474,
    height: 22.452,
    viewBox: "0 0 22.474 22.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_6036",
    "data-name": "Rettangolo 6036",
    width: 22.474,
    height: 22.452
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18000",
    "data-name": "Raggruppa 18000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_17999",
    "data-name": "Raggruppa 17999",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23793",
    "data-name": "Tracciato 23793",
    d: "M5.619,1.75c0-.4-.011-.775,0-1.151a.553.553,0,0,1,.59-.59A.549.549,0,0,1,6.8.593c0,.376,0,.752,0,1.143h8.862c0-.379,0-.762,0-1.145a.517.517,0,0,1,.353-.538.551.551,0,0,1,.661.13,1.05,1.05,0,0,1,.169.531c.026.337.007.678.007,1.037h4.849c.545,0,.767.224.767.775q0,9.579,0,19.157c0,.545-.225.769-.774.769H.771c-.547,0-.771-.224-.771-.772Q0,12.1,0,2.523c0-.549.223-.772.77-.772H5.619ZM21.248,21.235V2.968h-4.4c0,.4.014.782,0,1.167a.59.59,0,0,1-1.179-.049c0-.367,0-.734,0-1.113H6.805c0,.4.006.788,0,1.173a.528.528,0,0,1-.513.544.553.553,0,0,1-.665-.561c-.018-.384,0-.769,0-1.151H1.227V21.235Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23794",
    "data-name": "Tracciato 23794",
    d: "M39.248,96.705H34.936c-.538,0-.824-.353-.67-.812a.554.554,0,0,1,.489-.388,1.552,1.552,0,0,1,.221-.006c5.4,0,6.97,0,12.37,0,.305,0,.575.046.7.369a.591.591,0,0,1-.522.836c-.092.007-.185,0-.277,0h-8",
    transform: "translate(-29.926 -88.431)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a8b76a3b1fe885e02ed9bfc48a81185f.svg";
export { ForwardRef as ReactComponent };